import { Image, Container, Row, Col } from 'react-bootstrap';
import Sidebar from './AnimatedList';
import "./Services.css";

function Logistics() {
    return (
         <>
            <Image className="fade-in responsive-img" src="https://windward.ai/wp-content/uploads/2025/05/shipping-logistics-featured-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col md={8}>
                        <h1 className='text-center my-2 text-decoration-underline'><strong>Logistics and Warehousing</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Freight forwarding companies within provide warehousing services in different cities of the world for handling and storage of goods. Covered warehouses can be intended for piece and bulk cargo, which allows, regardless of weather conditions, to store goods in complete safety. Freight forwarders pass a special qualification, and as a rule they have a huge experience for all types of cargo and all the necessary equipment for this. Given that warehouses are often located right in the ports, the implementation of warehousing services becomes much easier and easier. The container terminal is located in the maximum proximity to the premises, which makes it possible to carry out the dispatch of containers promptly, without any delays. The huge covered warehouse is a spacious room in which your cargo will be in complete safety. Warehouse services can be provided as a whole complex, and selective services.</p>
                    </Col>
                    <Col md={4}>
                    <Sidebar/>
                    </Col>
                </Row>
            </Container>
           
        </>
    )
}

export default Logistics